import { Link } from "react-router-dom";
import { Link as LinkIcon, Facebook, Linkedin, Mail } from "lucide-react";
import { newServiceLinks } from "@/data/seoServicePages.mjs";

const Footer = () => {
  return (
    <footer className="bg-foreground py-12 md:py-16">
      <div className="container mx-auto px-4">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 md:gap-10 mb-10 md:mb-12">
          <div className="sm:col-span-2">
            <Link to="/" className="flex items-center gap-2 text-background mb-5 md:mb-6 active:scale-95 transition-transform">
              <div className="flex items-center justify-center w-10 h-10 bg-accent rounded-lg">
                <LinkIcon className="w-6 h-6" />
              </div>
              <span className="text-xl md:text-2xl font-bold">linkzy</span>
            </Link>
            <p className="text-background/70 mb-5 md:mb-6 text-sm md:text-base">
              We focus on the needs of small to middle market businesses to improve and grow their return.
            </p>
            <a href="mailto:contact@linkzy.io" className="flex items-center gap-2 text-background/70 hover:text-background transition-colors active:scale-95 text-sm md:text-base">
              <Mail className="w-4 h-4" />
              contact@linkzy.io
            </a>
          </div>

          <div>
            <h3 className="text-background font-semibold mb-4 md:mb-6 text-base md:text-lg">Company</h3>
            <ul className="space-y-2.5 md:space-y-3">
              <li>
                <Link to="/about" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  Link Building
                </Link>
              </li>
              <li>
                <Link to="/b2b-link-building" className="text-accent hover:text-accent/80 transition-colors active:scale-95 inline-block text-sm md:text-base font-semibold">
                  B2B Link Building
                </Link>
              </li>
              <li>
                <Link to="/gambling-link-building" className="text-accent hover:text-accent/80 transition-colors active:scale-95 inline-block text-sm md:text-base font-semibold">
                  Gambling Link Building
                </Link>
              </li>
              <li>
                <Link to="/guest-post-service" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  Guest Post Service
                </Link>
              </li>
              <li>
                <Link to="/ai-visibility-audit" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  Free AI Visibility Audit
                </Link>
              </li>
              <li>
                <Link to="/ai-visibility-checker" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  Free AI Visibility Checker
                </Link>
              </li>
              <li>

                <Link to="/pricing" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/compare" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  Compare
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-background font-semibold mb-4 md:mb-6 text-base md:text-lg">Services</h3>
            <ul className="space-y-2.5 md:space-y-3">
              {newServiceLinks.map(link => <li key={link.to}><Link to={link.to} className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">{link.label}</Link></li>)}
            </ul>
          </div>

          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-background font-semibold mb-4 md:mb-6 text-base md:text-lg">Industries</h3>
            <ul className="space-y-2.5 md:space-y-3">
              <li>
                <Link to="/industries/fintech" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  FinTech
                </Link>
              </li>
              <li>
                <Link to="/industries/insurance" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  Insurance
                </Link>
              </li>
              <li>
                <Link to="/industries/saas" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  SaaS
                </Link>
              </li>
              <li>
                <Link to="/industries/education" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  Education
                </Link>
              </li>
              <li>
                <Link to="/industries" className="text-accent hover:text-accent/80 transition-colors active:scale-95 inline-block text-sm md:text-base font-semibold">
                  All Industries
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-background font-semibold mb-4 md:mb-6 text-base md:text-lg">Legal</h3>
            <ul className="space-y-2.5 md:space-y-3">
              <li>
                <Link to="/terms" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-background/70 hover:text-background transition-colors active:scale-95 inline-block text-sm md:text-base">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background/20 pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-background/60 text-xs md:text-sm text-center md:text-left">
            © 2026 Linkzy All rights reserved.
          </p>
          
          <div className="flex items-center gap-3 md:gap-4">
            <a 
              href="https://www.facebook.com/linkzoio" 
              target="_blank" 
              rel="noopener noreferrer" 
              aria-label="Visit Linkzy on Facebook"
              className="w-11 h-11 md:w-10 md:h-10 bg-background/10 hover:bg-background/20 active:scale-95 rounded-lg flex items-center justify-center text-background transition-all"
            >
              <Facebook className="w-5 h-5" aria-hidden="true" />
            </a>
            <a 
              href="https://www.linkedin.com/company/linkzyy" 
              target="_blank" 
              rel="noopener noreferrer" 
              aria-label="Visit Linkzy on LinkedIn"
              className="w-11 h-11 md:w-10 md:h-10 bg-background/10 hover:bg-background/20 active:scale-95 rounded-lg flex items-center justify-center text-background transition-all"
            >
              <Linkedin className="w-5 h-5" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
